import type { TFunction } from 'i18next';
import type { RowAction } from 'design-system-web';

import { CoverageHoursTableRow } from './coverageHoursTableRows';

const isChildRow = (row: CoverageHoursTableRow) => row.isChild;

export function buildCoverageHoursRowActions(
  t: TFunction,
  onDelete: (row: CoverageHoursTableRow) => void,
  isDeleteDisabled: (row: CoverageHoursTableRow) => boolean
): RowAction<CoverageHoursTableRow>[] {
  return [
    {
      label: t('web.admin.serviceRequest.settings.coverageHours.actions.edit'),
      onClick: () => undefined,
      isHidden: isChildRow,
      testId: 'coverageHoursRowActionEdit',
    },
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.actions.delete'
      ),
      onClick: onDelete,
      isHidden: isChildRow,
      isDisabled: isDeleteDisabled,
      testId: 'coverageHoursRowActionDelete',
    },
  ];
}
